import React from "react";
import { useDispatch } from "react-redux";

import AnimatedDiv from "src/app/components/AnimatedDiv/AnimatedDiv";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ModalText } from "src/app/components/Modal/Modal";
import { setStoreConfigurationModalVisibility } from "src/redux";
import step1Video from "../../../videos/step-1.mp4";

interface Props {
  onClose: () => void;
}

export const StepOne: React.FC<Props> = (props) => {
  const { onClose } = props;

  const dispatch = useDispatch();

  const openConfiguration = () => {
    onClose();
    dispatch(setStoreConfigurationModalVisibility(true));
  };

  return (
    <AnimatedDiv>
      <span className="how-it-works__step-title">
        <IDHFormattedMessage
          id="ws_store_configuration"
          defaultMessage="Store configuration"
        />
      </span>
      <ModalText>
        <IDHFormattedMessage
          id="ws_how_it_works_step_1_a"
          defaultMessage="In the first step, set up your e-commerce platform. Go to"
        />
        &nbsp;
        <button
          className="how-it-works__link button-style-reset"
          onClick={openConfiguration}
          type="button"
        >
          &quot;
          <IDHFormattedMessage
            id="ws_store_configuration"
            defaultMessage="Store configuration"
          />
          &quot;
        </button>
        &nbsp;
        <IDHFormattedMessage
          id="ws_how_it_works_step_1_b"
          defaultMessage="where you will find full instructions for proper integration."
        />
      </ModalText>
      <video autoPlay loop>
        <source src={step1Video} type="video/mp4" />
      </video>
    </AnimatedDiv>
  );
};
